<template>
  <div class="container section" v-show="$canAccess(19, 5)">
    <div class="row heading">
      <div class="col">
        <h2>Permissions</h2>
      </div>
    </div>

    <div v-for="r in agentRolesPermissions" class="row commission-section" :class="{active: isActive(r)}" :key="r.role_id">

      <div class="col-6 section-header" @click.stop="setActive(r)">
        <strong><i class="fa fa-caret-right" /> &nbsp;{{r.name | uppercase}}</strong>
      </div>
      <div class="col-6 text-right">
        <button @click="editRole(r)" v-show="isActive(r) && selected.name != r.name"  class="btn btn-sm btn-primary"><i class="fa fa-gear"></i>&nbsp;&nbsp;Edit</button>
        <button @click="saveRoles()" v-show="isActive(r) && selected.name == r.name"  class="btn btn-sm btn-success"><i class="fa fa-check"></i>&nbsp;&nbsp;Save</button>
        <button @click="selected = {};" v-show="isActive(r) && selected.name == r.name" class="btn btn-sm btn-clear">Cancel</button>
      </div>

      <div class="container" v-show="!selected || selected.name != r.name">
        <div class="form-group row">
          <label class="col-12 col-sm-6 col-md-4 col-lg-3 col-form-label" v-for="p in r.rolesPermissions">
            <i class="fa" :class="[p.state ? 'fa-check text-success' : 'fa-remove subdued']"></i>
            <span :class="[p.state ? 'text-success' : 'subdued']">
              {{p.name}}
            </span>
          </label>
        </div>
      </div>


      <div class="container" v-show="selected && selected.name == r.name">
        <div class="form-group row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="p in selected.rolesPermissions">
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="p.state"
                   :true-value="1"
                   :false-value="0"
                >&nbsp;&nbsp;{{p.name}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>


<script type="text/babel">
  export default{
    data(){
      return{
        agentRolesPermissions: {},
        active: '',
        selected:{},
      }
    },
    computed:{

    },
    created(){
      this.fetchAgentRolesPermissions();
    },

    filters:{
      displayStatus(status){
        return (status == "1")? 'Active' : 'Inactive';
      },
      uppercase(string){
        if(!string) return null;
        return string.charAt(0).toUpperCase() + string.slice(1);

      }
    },
    methods:{
      isActive(role){
        return this.active == role.name;
      },
      setActive(role){

        this.selected = {};
        this.active = (this.active != role.name) ? role.name : null;


      },
      editRole(role){
        this.selected = JSON.parse(JSON.stringify(role));
      },
      saveRoles(){
        var _this = this;
        var data = this.selected;
        data.user_id = this.$route.params.agent_id;


        this.$send(this, 'userRolesPermissionsUpdate',data).then(r => {
          this.selected = {};
          this.fetchAgentRolesPermissions();
          this.$store.dispatch('setRoles');
        });

      },
      fetchAgentRolesPermissions(){
        this.$send(this, 'userRolesPermissions',{
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.agentRolesPermissions = r.userRolesPermissions;
        });

      },
    }
  }
</script>



// WEBPACK FOOTER //
// AgentPermissions.vue?5969788f